import React, { useEffect, useState } from "react";
import { Box, Heading, Text, Image, Flex } from "@chakra-ui/react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { BASE_URL_MEDIA, getAllInvitation } from "../../../../Redux/App/action";
import { getAllCategory } from "../../../../Redux/ProductController/action";
import { useCallback } from "react";

const AllInvitaions = () => {
  const dispatch = useDispatch();
  const [catData, setCatData] = useState([]);
  const param = useParams();
  const name = param._id;
  const [catId, setCatId] = useState("");
  const { allCat, isLoading } = useSelector((store) => store.prodReducer);

  useEffect(() => {
    dispatch(getAllCategory());
  }, [dispatch]);

  useEffect(() => {
    if (allCat && allCat.length > 0) {
      const greetingsCategory = allCat.find(
        (category) => category.categoryName.toUpperCase() === "INVITATIONS",
      );

      if (greetingsCategory) {
        setCatId(greetingsCategory.categoryId);
      }
    }
  }, [allCat]);

  const getSubCategoryData = useCallback(async () => {
    try {
      const response = await axios.post(
        `${BASE_URL_MEDIA}/media/file/admin/get/bycategoryIdSubCategoryId?categoryId=${catId}&subCategoryId=${name}`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
            Token: 123456,
          },
        },
      );
      if (response.status === 200) {
        setCatData(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  }, [catId, name]);

  useEffect(() => {
    if (catId) {
      getSubCategoryData();
    }
  }, [getSubCategoryData, catId]);

  return (
    <Box
      p={5}
      display={"grid"}
      gridTemplateColumns={{ md: "repeat(4,1fr)", base: "repeat(1,1fr)" }}
      gap={5}
    >
      {catData && catData.length > 0 ? (
        catData
          .filter((el) => el.mediaType === "TEMPLATE_PREVIEW")
          .map((el, i) => (
            <Link to={`/customizeInvitation/${el.sourceMediaId}`} key={i}>
              <Box boxShadow={"rgba(0, 0, 0, 0.24) 0px 3px 8px;"}>
                <Image
                  src={el.imageUrl}
                  alt="error"
                  w={{ md: "100%", base: "100%" }}
                  h={"100%"}
                />
                <Heading
                  fontSize={{
                    base: "14px",
                    md: "10px",
                    lg: "14px",
                    xl: "16px",
                  }}
                  fontFamily={"Sans serif"}
                  fontWeight={"semibold"}
                >
                  {el.cardName}
                </Heading>
                <Flex alignItems={"center"} justifyContent={"center"} gap={5}>
                  <heading className="font-semibold text-md">
                    ₹{el.discountedPrice}
                  </heading>
                  <Text
                    textDecoration={"line-through"}
                    color={"gray.600"}
                    fontSize={"sm"}
                  >
                    ₹{el.price}
                  </Text>
                </Flex>
              </Box>
            </Link>
          ))
      ) : (
        <Box>
          <Box margin={"auto"} w={"100%"} h={"80vh"}>
            <Text
              textAlign={"center"}
              fontWeight={"bold"}
              mt={5}
              className="oswald-font"
            >
              No Data Present For The Search.
            </Text>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default AllInvitaions;
